/* eslint-disable */
import { memo } from 'react';
import { CustomButton } from 'components';
import { useFormContext } from 'react-hook-form';

export const Footer = memo(() => {
  const {
    formState: { errors, isDirty, isValid },
    setValue,
    reset,
  } = useFormContext();

  const onSaveCampaign = async () => {
    // do save settings
    // implemented in form submit
  };

  const onCancel = () => {
    reset();
  };

  return (
    <>
      {/* {(result.isLoading || saveAndStartResult.isLoading) && <Loader.Global delay={1} />} */}
      <div style={{ marginTop: '16px', marginBottom: '16px', display: 'flex', gap: '16px' }}>
        <CustomButton
          type='submit'
          id='save_campaign'
          buttonColor={CustomButton.Colors.Primary}
          onClick={onSaveCampaign}
          disabled={!isDirty || !isValid}
        >
          Save Settings
        </CustomButton>
        <CustomButton
          id='cancel_campaign'
          buttonColor={CustomButton.Colors.Secondary}
          onClick={onCancel}
        >
          Cancel
        </CustomButton>
      </div>
    </>
  );
});
